import { ContentType, ApiErrorType } from 'interfaces';
import { AUTH_COOKIE_KEY } from 'utils/useAuthToken';
import i18next from 'i18next';

export const setCookie = (token: string) => {
  document.cookie = `${AUTH_COOKIE_KEY}=${token};path=/`;
};

export const sortContentBlocs = ({
  contentBlocs = [],
  ...otherProps
}: ContentType): ContentType => {
  const sortedContentBlocs = contentBlocs.sort(
    (a, b) => a.position - b.position,
  );
  return { ...otherProps, contentBlocs: sortedContentBlocs };
};

const getErrorsMessages = (errorList: { message: string }[] = []): string =>
  errorList.reduce(
    (acc: string, curr: { message: string }) => `${curr.message} ${acc}`,
    '',
  );

export const getProvidedByServerErrors = (error: ApiErrorType): string => {
  const violations = getErrorsMessages(error.response.data.violations);
  const exceptions = getErrorsMessages(error.response.data.error?.exception);
  const separator = violations.length ? ' - ' : '';

  if (error.response.data.error?.code === 400) {
    return i18next.t('auth.login.error400');
  }

  return `${violations}${separator}${exceptions}`;
};
